/**
 * Detective Pikachu search icon.
 *
 * Inline SVG — chunky 3-px navy stroke + flat fills to harmonise with the
 * storefront's warp-pipe cart. Pikachu's signature yellow + red-cheek
 * palette, topped with a brown deerstalker (the detective hat) and a
 * magnifying glass tucked in the corner so it still reads as "search".
 */
const DetectivePikachuSearch = ({ size = 28, className = '', 'data-testid': testId }) => {
  const w = size;
  const h = size;
  return (
    <svg
      width={w}
      height={h}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className={className}
      data-testid={testId}
    >
      {/* Ears — yellow base, black tip, slight outward tilt */}
      <polygon points="9,18 4,4 18,16" fill="#FFD803" stroke="#0A0A2E" strokeWidth="2.5" strokeLinejoin="round" />
      <polygon points="6,8 4,4 10,9" fill="#0A0A2E" />
      <polygon points="39,18 44,4 30,16" fill="#FFD803" stroke="#0A0A2E" strokeWidth="2.5" strokeLinejoin="round" />
      <polygon points="42,8 44,4 38,9" fill="#0A0A2E" />

      {/* Head (rounded square) */}
      <rect x="8" y="15" width="32" height="24" rx="7" ry="7"
            fill="#FFD803" stroke="#0A0A2E" strokeWidth="3" />

      {/* Deerstalker hat — brown band + side flap + top crown */}
      {/* Side ear flap */}
      <rect x="6" y="14" width="6" height="6" rx="1.5"
            fill="#8B5A2B" stroke="#0A0A2E" strokeWidth="2" />
      <rect x="36" y="14" width="6" height="6" rx="1.5"
            fill="#8B5A2B" stroke="#0A0A2E" strokeWidth="2" />
      {/* Hat band across forehead */}
      <rect x="10" y="13" width="28" height="6"
            fill="#A06A38" stroke="#0A0A2E" strokeWidth="2.5" />
      {/* Hat crown peak */}
      <path d="M16 13 L20 7 L28 7 L32 13 Z"
            fill="#8B5A2B" stroke="#0A0A2E" strokeWidth="2.5" strokeLinejoin="round" />
      {/* Crown highlight stripe */}
      <rect x="21" y="9" width="6" height="2.5" fill="#C08B58" />

      {/* Eyes */}
      <circle cx="17" cy="26" r="2.2" fill="#0A0A2E" />
      <circle cx="31" cy="26" r="2.2" fill="#0A0A2E" />
      {/* Eye glints */}
      <circle cx="17.7" cy="25.3" r="0.7" fill="#FFFFFF" />
      <circle cx="31.7" cy="25.3" r="0.7" fill="#FFFFFF" />

      {/* Cheeks */}
      <circle cx="13.5" cy="31" r="2.6" fill="#FF1FA8" stroke="#0A0A2E" strokeWidth="1.5" />
      <circle cx="34.5" cy="31" r="2.6" fill="#FF1FA8" stroke="#0A0A2E" strokeWidth="1.5" />

      {/* Tiny mouth */}
      <path d="M22 33 Q24 35 26 33" fill="none" stroke="#0A0A2E" strokeWidth="2" strokeLinecap="round" />

      {/* Magnifying glass — bottom-right corner, leans the icon toward "search" */}
      <circle cx="38" cy="38" r="6" fill="#FFFFFF" stroke="#0A0A2E" strokeWidth="2.5" />
      <circle cx="38" cy="38" r="3.2" fill="#00C2FF" opacity="0.5" />
      <line x1="42.5" y1="42.5" x2="46" y2="46" stroke="#0A0A2E" strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
};

export default DetectivePikachuSearch;
